import { Routes, Route } from "react-router-dom";
import { Suspense as ReactSuspense, createContext, useState } from "react";
import MainPage from "./MainPage/MainPage";
import OrdibeheshtMainPage from "../OrdibeheshtMainPage/OrdibeheshtMainPage";
import MainBlog from "../BlogPages/MainBlog";
import DetailBlog from "../BlogPages/DetailBlog";
import MainBasket from "../BasketPage/MainBasket";
import AboutUS from "../AboutUs/AboutUs";
import CallWithUs from "../CallWithUs/CallWithUs";
import Group from "../Group/Group";
import Product from "../Product/Product";
import Login from "../LoginRegister/Login";
import RequireAuth from "../RequireAuth";
import { AuthProvider } from "../../context/AuthProvider";
import SubGroups from "../Group/SubGroups";
import AllBlogs from "../BlogPages/AllBlogs";
import SearchPage from "./SearchPage";
import GoToTop from "../../hooks/GoTop";
import Panel from "../Panel/Panel";
import UserInformation from "../Panel/SadanPanel/UserInformation/UserInformation";
import UserDashboard from "../Panel/SadanPanel/MainDashboard/MainDashboard";
import Orders from "../Panel/SadanPanel/Orders/Orders";
import OrdersDetails from "../Panel/SadanPanel/Orders/OrdersDetials";
import AddressSelect from "../BasketPage/AddressSelect/AddressSelect";
import PaymentResult from "../BasketPage/PaymentResult";
import TagPage from "../BlogPages/TagPage";
import { ShopWidgetProvider } from "../../context/ShopWidgetProvider";
import Loader from "../Loader/Loader";
import WalletCharge from "../Panel/SadanPanel/Wallet/WalletCharge";

export const SaleContext = createContext();
export const SetSaleContext = createContext();
export const SetDiscountContext = createContext();

const Suspense = ({ element }) => (
	<ReactSuspense fallback={<Loader />}>{element}</ReactSuspense>
);

const Pages = () => {
	const [factorNum, setFactorNum] = useState(0);
	const [discountValue, setDiscountValue] = useState(0);
	const [discountType, setDiscountType] = useState("");
	const [discountCode, setDiscountCode] = useState("");
	const [finalDiscount, setFinalDiscount] = useState("");
	const [finalPrice, setFinalPrice] = useState(1000);

	return (
		<AuthProvider>
			<ShopWidgetProvider>
				<SetDiscountContext.Provider
					value={{
						value: discountValue,
						setValue: (value) => setDiscountValue(value),
						type: discountType,
						setType: (theType) => setDiscountType(theType),
						code: discountCode,
						setCode: (theCode) => setDiscountCode(theCode),
            			discount: finalDiscount,
						setDiscount: (theDiscount) => setFinalDiscount(theDiscount),
						finalPrice: finalPrice,
						setFinalPrice: (thePrice) => setFinalPrice(thePrice),
					}}
				>
					<SetSaleContext.Provider value={setFactorNum}>
						<SaleContext.Provider value={factorNum}>
							<Routes>
								<Route
									path="/login"
									element={<Suspense element={<Login />} />}
								/>
								<Route
									exact
									path="/"
									element={
										<Suspense element={<MainPage />} />
									}
								>
									<Route
										path="/"
										element={
											<Suspense
												element={
													<OrdibeheshtMainPage />
												}
											/>
										}
									/>
									<Route
										path="/Blog"
										element={
											<Suspense element={<MainBlog />} />
										}
									/>
									<Route
										path="/allBlogs"
										element={
											<Suspense element={<AllBlogs />} />
										}
									/>
									<Route path="/Group/product">
										<Route
											path=":id"
											element={
												<Suspense
													element={<Product />}
												/>
											}
										/>
									</Route>
									<Route path="/Blog/tag">
										<Route
											path=":tag"
											element={
												<Suspense
													element={<TagPage />}
												/>
											}
										/>
									</Route>
									<Route
										path="/Group"
										element={
											<Suspense element={<Group />} />
										}
									/>
									<Route path="/DetailBlog">
										<Route
											path=":id"
											element={
												<Suspense
													element={<DetailBlog />}
												/>
											}
										/>
									</Route>
									<Route
										path="/Search"
										element={
											<Suspense
												element={<SearchPage />}
											/>
										}
									/>
									<Route
										element={
											<Suspense
												element={<RequireAuth />}
											/>
										}
									>
										<Route
											path="/Basket"
											element={
												<Suspense
													element={<MainBasket />}
												/>
											}
										/>
										<Route
											path="/paymentResult"
											element={
												<Suspense
													element={<PaymentResult />}
												/>
											}
										/>
									</Route>
									<Route path="/Group/SubGroups">
										<Route
											path=":group"
											element={
												<Suspense
													element={<SubGroups />}
												/>
											}
										/>
									</Route>
									<Route
										path="/AboutUS"
										element={
											<Suspense element={<AboutUS />} />
										}
									/>
									<Route
										path="/CallWithUs"
										element={
											<Suspense
												element={<CallWithUs />}
											/>
										}
									/>
								</Route>
								<Route
									element={
										<Suspense
											element={
												<RequireAuth panelType="user" />
											}
										/>
									}
								>
									<Route
										exact
										path="/"
										element={
											<Suspense
												element={<Panel type="user" />}
											/>
										}
									>
										<Route
											path="/user"
											element={
												<Suspense
													element={<UserDashboard />}
												/>
											}
										/>
										<Route
											path="/userInformation"
											element={
												<Suspense
													element={
														<UserInformation />
													}
												/>
											}
										/>
										<Route
											path="/address"
											element={
												<Suspense
													element={<AddressSelect />}
												/>
											}
										/>
										<Route
											path="/orders"
											element={
												<Suspense
													element={<Orders />}
												/>
											}
										/>
										<Route
											path="/ordersDetails"
											element={
												<Suspense
													element={<OrdersDetails />}
												/>
											}
										/>
										<Route
											path="/wallet/charge"
											element={
												<Suspense
													element={<WalletCharge />}
												/>
											}
										/>
									</Route>
								</Route>
							</Routes>
						</SaleContext.Provider>
					</SetSaleContext.Provider>
				</SetDiscountContext.Provider>

				<GoToTop />
			</ShopWidgetProvider>
		</AuthProvider>
	);
};
export default Pages;
